import { render, staticRenderFns } from "./FavoritesList.vue?vue&type=template&id=af97f944&scoped=true"
import script from "./FavoritesList.vue?vue&type=script&lang=js"
export * from "./FavoritesList.vue?vue&type=script&lang=js"
import style0 from "./FavoritesList.vue?vue&type=style&index=0&id=af97f944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af97f944",
  null
  
)

export default component.exports